import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { PolygonFormSchema } from 'src/models/polygon.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const PolygonForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={PolygonFormSchema}
      >
        {({ control, errors, formState }) => {
            handleEnable(formState.isDirty);

            return (
              <ATMGrid>
                <ATMGrid.Row columns="2">
                  <ATMGrid.Column>
                    <ATMField
                      label={Lang.LBL_Polygon}
                      name="polygon"
                      control={control}
                      as={ATMInput}
                      placeholder={Lang.LBL_ENTER}
                      clearable
                      required
                      error={errors.polygon}
                    />
                    <ATMField
                      as={ATMInput}
                      type="hidden"
                      name="polygonId"
                      control={control}
                      error={errors.polygonId}
                    />
                  </ATMGrid.Column>
                </ATMGrid.Row>
              </ATMGrid>
            );
          }}
      </ATMForm>
    </div>
  );
};

export default PolygonForm;
